/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Type_PackagingInputs */

const vi_warehouse_position_type_packaging = /** @type {(inputs: Warehouse_Position_Type_PackagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô vật tư`)
};

/**

* @param {Warehouse_Position_Type_PackagingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_type_packaging = /** @type {((inputs?: Warehouse_Position_Type_PackagingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Type_PackagingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_type_packaging(inputs)
});